import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import HorizontalForm from './components/billwisecasepicksheetreport';


const billwisecasepicksheetreport = ({ t }) => (
  <Container>
    <Row>
      <Col md={12}>
        <h3 className="page-title">REPORTS - Billwise To case Picksheet </h3>
      </Col>
    </Row>
   
    <Row>
      <HorizontalForm />
    </Row>

    
  </Container>
);

billwisecasepicksheetreport.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation('common')(billwisecasepicksheetreport);
